import React, { useContext } from "react";
import { ReactComponent as ArrowSort } from "./img/upDown.svg";
import { ReactComponent as ExternalLink } from "./img/ExternalLink.svg";
import AudienceLine from "./AudienceLine";
import { AudiencesContainer, StatsTable, StatsTableColHead, StatsTitle } from "./audiences.style";
import IntegrateFBMsg from "./IntegrateFBMsg";
import FixelDataContext from "../../../context/FixelDataContext";

const Audiences = () => {
    const { fullFixelData } = useContext(FixelDataContext);

    const renderAudienceLines = () => {
        return fullFixelData.facebook.audience.map((audience) => {
            return <AudienceLine key={audience.aud_id} fbAudience={audience} />;
        });
    };
    const renderAudienceHead = () => {
        return (
            <>
                <StatsTableColHead>
                    <span>Audience</span>
                    {fullFixelData.facebook.audience.length > 1 && <ArrowSort />}
                </StatsTableColHead>
                <StatsTableColHead>
                    <span>Size</span>
                    {fullFixelData.facebook.audience.length > 1 && <ArrowSort />}
                </StatsTableColHead>
                <StatsTableColHead>
                    <span>Status</span>
                    {fullFixelData.facebook.audience.length > 1 && <ArrowSort />}
                </StatsTableColHead>
            </>
        );
    };

    const renderAudienceTable = () => {
        // act_1086141482084 --> ["act", "1086141482084"] --> 1086141482084
        const FBAccountId = fullFixelData.facebook.audience[0].account.split("_")[1];
        return (
            <>
                <StatsTitle>
                    <h3>Facebook Audiences</h3>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={`https://business.facebook.com/adsmanager/audiences?act=${FBAccountId}`}>
                        <ExternalLink />
                    </a>
                </StatsTitle>
                <StatsTable>
                    {renderAudienceHead()}
                    {renderAudienceLines()}
                </StatsTable>
            </>
        );
    };

    const renderAudienceContent = () => {
        if (
            !fullFixelData.facebook ||
            fullFixelData.facebook.status === "not connected" ||
            (fullFixelData.install_data && !fullFixelData.install_data.options.fb)
        ) {
            return <IntegrateFBMsg />;
        }
        if (
            fullFixelData.facebook.status === "connected" &&
            fullFixelData.facebook.audience &&
            fullFixelData.facebook.audience.length
        ) {
            return renderAudienceTable();
        }
    };

    return <AudiencesContainer>{renderAudienceContent()}</AudiencesContainer>;
};
export default Audiences;